module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-408.2553c70.woff2";